import {StyleSheet} from '@react-pdf/renderer';

import {greenColors} from '../../../../../../layouts/theme/designSystem';

const barColor = greenColors[70];

export const questionCardScalesStyles = StyleSheet.create({
  legendContainer: {
    backgroundColor: '#163438',
    height: '28px',
    borderRadius: 8,
    padding: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 8,
  },
  legendBar: {
    height: '12px',
    width: '3px',
    borderRadius: 8,
    marginRight: 4,
  },
  legendText: {
    color: `${greenColors[700]}`,
    fontSize: '10px',
  },
  container: {
    position: 'relative',
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  backgroundBar: {
    position: 'absolute',
    backgroundColor: barColor,
    height: 3,
    width: '100%',
    borderRadius: 2,
  },
  bubble: {
    borderRadius: '50%',
    zIndex: 1,
    backgroundColor: barColor,
    width: 14,
    height: 14,
  },
  bubbleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    position: 'relative',
    top: -5.5,
  },
  valueLine: {
    position: 'absolute',
    width: '3px', // Thin line
    height: '18px', // Adjust based on your design
    top: '-2px', // Adjust vertical position if needed
    borderRadius: '4px',
  },
});
